import { NgModule } from "@angular/core";
import { ReducerConfig, ReducerToken } from "./model/reducer-config.model";
import { CoreState } from "./model/common/core.state.model";
import { ReduxAction, RESET_PRIVATE_REDUX_STATE } from "./model/redux.action.model";
import { ReduxConfigService, ReduxConfigServiceToken } from "./service/redux-config.service";
import { ReduxConfigServiceImpl } from "./service/redux-config.service.impl";
import { CoreActionFactoryImpl } from "./action/common/core.action.factory.impl";
import {
  CoreActionFactory, CoreActionFactoryToken,
  END_BACKEND_COMMUNICATION, RESET_REDUX_STATE,
  START_BACKEND_COMMUNICATION
} from "./action/common/core.action.factory";
import { CORE_STATE_NAME, coreReducer } from "./reducer/common/core.reducer";
import { DEFAULT_STATE_NAME, defaultReducer } from "./reducer/default/default.reducer";
import { RESOURCES_STATE_NAME, resourcesReducer } from "./reducer/resources/resources.reducer";
import { DefaultActionFactoryImpl } from "../redux/action/default/default.action.factory.impl";
import { DefaultActionFactory, DefaultActionFactoryToken,
  CONFIRM_LOGIN_RECEIVE, CONFIRM_LOGIN_REQUEST,
  LOGIN_RECEIVE, LOGIN_REQUEST,
  MODIFY_STATIC_PASSWORD_RECEIVE, MODIFY_STATIC_PASSWORD_REQUEST,
  GET_STATUS_RECEIVE, GET_STATUS_REQUEST } from "../redux/action/default/default.action.factory";
import { DefaultState } from "../redux/model/default/default.state.model";
import { ResourcesState } from "../redux/model/default/resources.state.model";
import { StoreModule } from "@ngrx/store";
import {
  CommunicationResponseState
} from "./model/common/communication-response.state.model";

@NgModule({
  imports: [
    StoreModule.forFeature(CORE_STATE_NAME, coreReducer),
    StoreModule.forFeature(DEFAULT_STATE_NAME, defaultReducer),
    StoreModule.forFeature(RESOURCES_STATE_NAME, resourcesReducer)
  ],
  providers: [
    { provide: CoreActionFactoryToken, useClass: CoreActionFactoryImpl },
    { provide: ReduxConfigServiceToken, useClass: ReduxConfigServiceImpl },
    { provide: DefaultActionFactoryToken, useClass: DefaultActionFactoryImpl }
  ]
})
class ReduxModule {}

export {
  CoreActionFactory,
  CoreActionFactoryToken,
  CoreActionFactoryImpl,
  START_BACKEND_COMMUNICATION,
  END_BACKEND_COMMUNICATION,
  CORE_STATE_NAME,
  CoreState,
  // reducer
  ReducerConfig,
  ReducerToken,
  ReduxModule,
  RESET_REDUX_STATE,
  // redux
  ReduxAction,
  ReduxConfigService,
  ReduxConfigServiceToken,
  ReduxConfigServiceImpl,

  CommunicationResponseState,
  // otherservices
  DefaultActionFactory,
  DefaultActionFactoryToken,
  DefaultActionFactoryImpl,
  LOGIN_REQUEST,
  LOGIN_RECEIVE,
  CONFIRM_LOGIN_REQUEST,
  CONFIRM_LOGIN_RECEIVE,
  MODIFY_STATIC_PASSWORD_REQUEST,
  MODIFY_STATIC_PASSWORD_RECEIVE,
  GET_STATUS_REQUEST,
  GET_STATUS_RECEIVE,
  RESET_PRIVATE_REDUX_STATE,
  DefaultState,
  ResourcesState
};
